import { DATE_FORMATS, TableTitles } from "@/constants";
import { TableProps } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { AntdTable } from "../common";

type AttendanceTableProps = {
	dataSource: TableProps<Meditator>["dataSource"];
	currentPage: number;
} & Omit<TableProps<Meditator>, "dataSource" | "columns">;

export function AttendanceTable({
	dataSource,
	currentPage,
	...props
}: AttendanceTableProps) {
	const columns: ColumnsType<Meditator> = [
		{
			title: TableTitles.No,
			key: "no.",
			render: (value, record, index) =>
				(dataSource?.length || 0) * (currentPage - 1) + (index + 1),
		},
		{
			title: TableTitles.registrant_book_id,
			dataIndex: ["book", "bookNo"],
			key: "bookNo",
		},
		{
			title: TableTitles.registrant_name,
			dataIndex: "name",
			key: "name",
		},
		{
			title: "Check In Time",
			dataIndex: "clockInAt",
			key: "clockIn",
			render: (value) =>
				value
					? dayjs(value).format(DATE_FORMATS.DATE_TIME_FORMAT)
					: "-",
			align: "center",
		},
		{
			title: "Check Out Time",
			dataIndex: "clockOutAt",
			key: "clockOut",
			render: (value) =>
				value
					? dayjs(value).format(DATE_FORMATS.DATE_TIME_FORMAT)
					: "-",
			align: "center",
		},
	];

	return <AntdTable dataSource={dataSource} columns={columns} {...props} />;
}
